import { breakpoints } from '@src/common/breakpoints';
import Paper from '@src/components/reusable/Paper';
import styled from 'styled-components';

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1375px;
  margin: 0 auto;
  align-items: flex-start;
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.smallTablet}) {
    margin-bottom: 158px;
  }
`;

export const Steps = styled('div')`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: flex-start;
  flex-basis: calc(66.66% - 24px);
  overflow: hidden;

  @media (max-width: ${breakpoints.mediumTablet}) {
    padding-right: 16px;
    flex-direction: column;
    flex-basis: calc(50% - 16px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding-right: 16px;
    flex-basis: initial;
  }
`;

export const Step = styled(Paper)`
  width: 100%;

  flex-grow: 1;
`;

export const Summary = styled(Paper)`
  width: 100%;

  flex-basis: calc(33.33% - 24px);

  @media (max-width: ${breakpoints.mediumTablet}) {
    flex-basis: calc(50% - 24px);
  }
  @media (max-width: ${breakpoints.smallTablet}) {
    display: none;
  }
`;

interface StepHeaderProps {
  $disabled?: boolean;
}
export const StepHeader = styled.div<StepHeaderProps>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  @media (max-width: ${breakpoints.smallTablet}) {
    padding: 16px;
  }
`;

interface StepTitleProps {
  $finished?: boolean;
}

export const StepTitle = styled.div<StepTitleProps>`
  font-size: 23px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  color: ${({ $finished }) => ($finished ? '#0E8B51' : '#333333')};

  @media (max-width: ${breakpoints.smallTablet}) {
    font-size: 28px;
    line-height: 34px;
  }
`;

interface StepNumberProps {
  $finished?: boolean;
}

export const StepNumber = styled.div<StepNumberProps>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  color: #ffffff;
  background-color: ${({ $finished }) => ($finished ? '#0E8B51' : '#333333')};

  font-size: 23px;
  font-weight: 700;
  line-height: 28px;
`;

export const StepContainer = styled.div`
  padding: 8px 24px 24px;
`;
